import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
  align?: "left" | "center";
}

export default function SectionHeader({
  title,
  subtitle,
  moreLink,
  moreText = "查看更多",
  align = "left",
}: SectionHeaderProps) {
  return (
    <div
      className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between ${
        align === "center" ? "sm:items-center" : ""
      }`}
    >
      <div className={align === "center" ? "mx-auto text-center" : ""}>
        <div className="flex items-center gap-2.5">
          <span className="h-5 w-1 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-xs text-foreground-600 md:text-sm">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="group inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 transition-colors hover:text-primary-700 md:text-sm"
        >
          全部{moreText}
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
        </Link>
      )}
    </div>
  );
}